import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import AuthenticationUtil from 'utils/AuthenticationUtil';
import NavigationUtil from 'utils/NavigationUtil';
import templateHtml from 'templates/main/MainContainer/UserPopupMenuView.html';
import { isReadonlyMode } from 'system/SystemUtil';
import { isCDCUser, isChinaUser } from 'utils/ChinaUtil';
import ReactComponentView from 'views/main/react/ReactComponentView';
import CookiePreferencesLink from 'standaloneComponents/Consent/CookiePreferencesLink';

var Events = {
    ON_NAVIGATION: 'ON_NAVIGATION'
};

var UserPopupMenuView = Backbone.View.extend({
    events: {
        'click .view-profile': 'navigateLink',
        'click .account-settings': 'navigateLink',
        'click .sign-out': 'onSignOutClicked'
    },

    template: _.template(templateHtml),

    initialize: function(args) {
        this.viewerSocialProfile = args.viewerSocialProfile;

        this.profileUrl = NavigationUtil.url(`/profile/${this.viewerSocialProfile.get('displayName')}`);
        this.settingsUrl = NavigationUtil.url('/settings');

        this.initializeSupportAndLegalUrls();
    },

    initializeSupportAndLegalUrls: function() {
        let rootUrl = 'https://www.garmin.com';
        if (isCDCUser()) {
            rootUrl = 'https://www.garmin.cn/zh-CN';
        } else if (isChinaUser()) {
            rootUrl = 'https://wwwus.garmin.cn/zh-CN';
        }

        // Support URLs
        this.helpUrl = '/help';
        this.statusUrl = '/status';

        // Legal URLs
        this.termsOfUseUrl = `${rootUrl}/legal/terms-of-use/`;
        this.privacyUrl = `${rootUrl}/privacy/connect/`;
        this.securityUrl = `${rootUrl}/legal/security`;
        this.licensesUrl = `${rootUrl}/legal/connect_copyrights`;
    },

    /**
     * Render the template.
     */
    render: function() {
        var html = this.template({
            Localizer: Localizer,
            fullName: this.viewerSocialProfile.get('fullName') || this.viewerSocialProfile.get('displayName'),
            profileUrl: this.profileUrl,
            settingsUrl: this.settingsUrl,
            helpUrl: this.helpUrl,
            statusUrl: this.statusUrl,
            termsOfUseUrl: this.termsOfUseUrl,
            privacyUrl: this.privacyUrl,
            securityUrl: this.securityUrl,
            year: this.getCurrentYear(),
            isReadOnly: isReadonlyMode(),
            licensesUrl: this.licensesUrl
        });

        this.$el.html(html);

        this.renderCookieConsentLink();
    },

    renderCookieConsentLink: function() {
        this.cookieConsent = new ReactComponentView();

        // Manually remove react component if it's mounted to prevent errors
        if (this.cookieConsent && this.cookieConsent.element) {
            this.cookieConsent.removeElement();
        }

        this.cookieConsent.renderComponent(CookiePreferencesLink, this.$('#cookie_preferences_container')[0]);
    },

    navigateLink: function(e) {
        if (!e.ctrlKey && !e.metaKey) {
            e.preventDefault();
        }

        this.trigger(Events.ON_NAVIGATION);
        NavigationUtil.anchorTagHandler(e);
    },

    onSignOutClicked: function(e) {
        e.preventDefault();
        AuthenticationUtil.signOut();
    },

    getCurrentYear: function() {
        return new Date().getFullYear();
    }
});

UserPopupMenuView.Events = Events;

export default UserPopupMenuView;
